"use strict";
/** This file provides a framework for extending heatmap behavior via Extensions.
 * Extension lifetime:
 * - When an Extension is registered with a heatmap instance:
 *   - The Extension creates an instance of Behavior, bound to the heatmap State
 *   - The Behavior runs `register` method
 * - The Behavior can be later modified by `update` method
 * - The Behavior can be later removed by `unregister` method
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Extension = exports.BehaviorBase = void 0;
var utils_1 = require("./utils");
/** Base class for creating Behavior classes */
var BehaviorBase = /** @class */ (function () {
    function BehaviorBase(state, params) {
        this.state = state;
        this.params = params;
        this.subscriptions = [];
    }
    BehaviorBase.prototype.register = function () { };
    ;
    BehaviorBase.prototype.update = function (params) {
        this.params = (0, utils_1.shallowMerge)(this.params, params);
    };
    ;
    BehaviorBase.prototype.unregister = function () {
        this.unsubscribeAll();
    };
    ;
    BehaviorBase.prototype.subscribe = function (subject, observer) {
        var _this = this;
        var sub = subject.subscribe(observer);
        this.subscriptions.push(sub);
        var unsubscribe = function () {
            (0, utils_1.removeElement)(_this.subscriptions, sub);
            sub.unsubscribe();
        };
        return {
            unsubscribe: unsubscribe,
        };
    };
    ;
    BehaviorBase.prototype.unsubscribeAll = function () {
        for (var _i = 0, _a = this.subscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            sub.unsubscribe();
        }
        this.subscriptions.length = 0;
    };
    ;
    return BehaviorBase;
}());
exports.BehaviorBase = BehaviorBase;
exports.Extension = {
    /** Create an Extension based on a behavior class */
    fromBehaviorClass: function (p) {
        return {
            name: p.name,
            defaultParams: p.defaultParams,
            create: function (state, params) { return new p.behavior(state, (0, utils_1.shallowMerge)(p.defaultParams, params)); },
        };
    },
};
